import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

import * as Sentry from '@sentry/browser';

Sentry.init({ dsn: 'https://336d1aa060a94f8f916c1e93d6affab7@o393426.ingest.sentry.io/5244378' });

const empresasModule = {
	state: {
		anexos: '',
		datosEmpresa: '',
		contactosEmpresa: '',
		busquedas : '',
		candidatosPracticas : '',
		candidatosEmpleo : ''
	},
	getters: {
		getAnexos: state => state.anexos,
		getDatosEmpresa: state => state.datosEmpresa,
		getContactosEmpresa: state => state.contactosEmpresa,
		getBusquedas: state => state.busquedas,
		getCandidatosPracticas : state => state.candidatosPracticas,
		getCandidatosEmpleo : state => state.candidatosEmpleo
	},
	actions: {
		requestAnexos({ commit }) {
			return new Promise((resolve, reject) => {
				axios.get('/api/Empresa/dameAnexosPracticas').then(result => {
					if (result.data.status == 0) {
						commit('setAnexos', result.data.datos);
						resolve(true);
					} else {
						commit('setError', result.data.status)
						reject(false);
					}

				}).catch(error => {
					reject(false);
				});
			});
		},
		requestDatosEmpresa({ commit }) {
			return new Promise((resolve, reject) => {
				axios.get('/api/Empresa/dameDatosEmpresa').then(result => {
					if (result.data.status == 0) {
						commit('setDatosEmpresa', result.data.datos);
						resolve(true);
					} else {
						commit('setError', result.data.status)
						reject(false);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		requestContactosEmpresa({ commit }) {
			return new Promise((resolve, reject) => {
				axios.get('/api/Empresa/dameContactosEmpresa').then(result => {
					if (result.data.status == 0) {
						commit('setContactosEmpresa', result.data.datos);
						resolve(true);
					} else {
						commit('setError', result.data.status)
						reject(false);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		requestNumeroProcesos({commit}){
			return new Promise((resolve, reject) => {
				axios.get('/api/Empresa/dameNumProcesos').then(result => {
					if (result.data.status == 0) {
						resolve(result.data.datos);
					} else {
						commit('setError', result.data.status)
						reject(false);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		requestProcesos({commit},data){

			let url = `/api/empresa/dameprocesos${data.type}${(data.historico) ? 'historico' : 'activos'}`;

			return new Promise((resolve, reject) => {
				axios.get(url).then(result => {
					if (result.data.status == 0) {
						resolve(result.data.datos);
					} else {
						commit('setError', result.data.status)
						reject(false);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		requestProceso({commit},slug){

			return new Promise((resolve, reject) => {
				axios.get(`/api/empresa/dameoferta/${slug}`).then(result => {
					if (result.data.status == 0) {
						resolve(result.data.datos);
					} else {
						commit('setError', result.data.status)
						reject(false);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		requestCandidatos({commit},slug){

			return new Promise((resolve, reject) => {
				axios.get(`/api/empresa/dameCandidatosOferta/${slug}`).then(result => {
					if (result.data.status == 0) {
						resolve(result.data.datos);
					} else {
						commit('setError', result.data.status)
						reject(false);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		cambiarEstadoCandidato({commit},data){

			return new Promise((resolve, reject) => {
				axios.post(`/api/empresa/cambiaEstadoCandidatura`, data).then(result => {
					if (result.data.status == 0) {
						resolve(true);
					} else {
						commit('setError', result.data.status)
						reject(false);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		requestCandidato({commit},id){
			return new Promise((resolve, reject) => {
				axios.get(`/api/empresa/dameCandidato/${id}`).then(result => {
					if (result.data.status == 0) {
						commit('setCV', result.data.datos.alumno);
						resolve(true);
					} else {
						commit('setError', result.data.status)
						reject(false);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		addOferta({commit},data){
			return new Promise((resolve, reject) => {
				axios.post(`/api/empresa/addOferta/`,data).then(result => {
					if (result.data.status == 0) {
						if(!!!result.data.mensaje){
							commit('setError', 605)
							resolve(true);
						}else{
							resolve(result.data.mensaje)
						}
					} else {
						commit('setError', result.data.status)
						resolve(false);
						Sentry.configureScope(function(scope) {
							scope.setExtra("to_server", data);
							Sentry.captureException(result.data);
						});


					}
				}).catch(error => {
					Sentry.captureException(error);
				});
			});
		},
		addBusquedaAlaCarta({commit},data){
			return new Promise((resolve, reject) => {
				axios.post(`/api/empresa/realizaBusquedaAlaCarta/`,data).then(result => {
					if (result.data.status == 0) {
						resolve(result.data.datos)
					} else {
						commit('setError', result.data.status)
						reject(false);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		getBusquedasRealizadas({commit}){
			return new Promise((resolve, reject) => {
				axios.get(`/api/Empresa/busquedasAlaCartaRealizadas`).then(result => {
					if (result.data.status == 0) {
						commit('setBusquedas',result.data.datos);
						resolve(true);
					} else {
						commit('setError', result.data.status)
						reject(false);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		sendCandidatosBusqueda({commit},data){
			return new Promise((resolve, reject) => {
				axios.post(`/api/Empresa/solicitarCandidatosBusquedaAlaCarta/`,data).then(result => {
					if (result.data.status == 0) {
						resolve(true);
						commit('setError', 608)
					} else {
						commit('setError', result.data.status)
						reject(false);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		requestCandidatosBusqueda({commit,getters,dispatch},id){

			if(!!!getters.getBusquedas){
				dispatch('getBusquedasRealizadas');
			}

			return new Promise((resolve, reject) => {
				axios.get(`/api/Empresa/dameCandidatosBusqueda/`+id).then(result => {
					if (result.data.status == 0) {
						resolve(result.data.datos)
					} else {
						commit('setError', result.data.status)
						reject(false);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		comprobarCIF({commit},cif){
			return new Promise((resolve, reject) => {
				axios.get(`/api/Empresa/existeCIF/${cif}/Ue567T3P`).then(result => {
					if (result.data.status == 0) {
						resolve(result.data.datos)
					} else {
						commit('setError', result.data.status)
						reject(false);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		requestRegistroEmpresa({commit},data){
			return new Promise((resolve, reject) => {
				axios.post(`/api/Empresa/guardarUsuarioEmpresa`,data).then(result => {
					if (result.data.status == 0) {
						resolve(result);
					} else {
						commit('setError', result.data.status)
						reject(false);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		setNewPass({commit},data){
			return new Promise((resolve, reject) => {
				axios.post(`/api/Empresa/restablecerPassword`,data).then(result => {
					if (result.data.status == 0) {
						resolve(true);
						commit('setError', 614)
					} else {
						commit('setError', result.data.status)
						reject(false);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		requestCandidatosPracticas({commit}){
			return new Promise((resolve, reject) => {
				axios.get(`/api/Empresa/dameCandidatosOfertasActivasPracticas`).then(result => {
					if (result.data.status == 0) {
						resolve(true);
						commit('setCandidatosPracticas', result.data.datos);
					} else {
						commit('setError', result.data.status)
						reject(false);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		requestCandidatosEmpleo({commit}){
			return new Promise((resolve, reject) => {
				axios.get(`/api/Empresa/dameCandidatosOfertasActivasYbusquedaEmpleo`).then(result => {
					if (result.data.status == 0) {
						resolve(true);
						commit('setCandidatosEmpleo', result.data.datos);
					} else {
						commit('setError', result.data.status)
						reject(false);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		modifyContacto({commit,dispatch},data){

			let url = (!!data.idContacto) ? '/api/Empresa/editContactoEmpresa' : '/api/Empresa/addContactoEmpresa'

			return new Promise((resolve, reject) => {
				axios.post(url,data).then(result => {
					if (result.data.status == 0) {
						dispatch("requestContactosEmpresa").then(r => {
							resolve(true);
							if(!!!data.idContacto){
								commit('setError', 609)
							}else{
								commit('editNombre',data);
								commit('setError', 610)
							}
						})
					} else {
						commit('setError', result.data.status)
						reject(false);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		requestBannerHome({commit}){
			return new Promise((resolve, reject) => {
				axios.get(`/api/Empresa/dameBanner`).then(result => {
					if (result.data.status == 0) {
						resolve(result.data.datos);
					} else {
						commit('setError', result.data.status)
						reject(false);
					}
				}).catch(error => {
					reject(false);
				});
			});
		}
	},
	mutations: {
		setAnexos(state, anexos) {
			state.anexos = anexos
		},
		setDatosEmpresa(state, datos) {
			state.datosEmpresa = datos
		},
		setContactosEmpresa(state, datos) {
			state.contactosEmpresa = datos
		},
		setBusquedas(state, datos) {
			state.busquedas = datos
		},
		setCandidatosPracticas(state, datos){
			datos.forEach(e =>{
				e.practicas = true;
			})
			state.candidatosPracticas = datos;
		},
		setCandidatosEmpleo(state, datos){
			state.candidatosEmpleo = datos;
		},
		
	}
}

export default empresasModule;



// WEBPACK FOOTER //
// ./src/store/empresasModule.js